import { mapEnumToOptions } from '@abp/ng.core';

export enum TerminalPaymentStatus {
  Pending = 0,
  Processing = 1,
  Succeeded = 2,
  Failed = 3,
  Cancelled = 4,
  Refunded = 5,
}

export const terminalPaymentStatusOptions = mapEnumToOptions(TerminalPaymentStatus);
